import Iconify from '../../components/Iconify';
import { DEALER_SCREEN } from '../../constant';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'Admin',
    path: '',
    icon: getIcon('bi:person-fill'),
    children: [
      {
        title: 'Add Client',
        path: '/dashboard/company',
        icon: getIcon('eva:shopping-bag-fill')
      },
      {
        title: 'Client List',
        path: '/dashboard/companies',
        icon: getIcon('eva:shopping-bag-fill')
      },{
        title: 'DSA Client List',
        path: '/dashboard/dsa',
        icon: getIcon('eva:shopping-bag-fill')
      },{
        title: 'Add User',
        path: '/dashboard/user',
        icon: getIcon('eva:shopping-bag-fill')
      },
      {
        title: 'All Users',
        path: '/dashboard/users',
        icon: getIcon('eva:shopping-bag-fill')
      }
    ]
  },
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: getIcon('eva:pie-chart-2-fill')
  },
  {
    title: DEALER_SCREEN.ALL_LOANS,
    path: '/dealers/loan_list/all',
    icon:  getIcon('mdi:circle-small')
  },
  {
    title: DEALER_SCREEN.PENDING_LOANS,
    path: '/dealers/loan_list/pending_loans',
    icon: getIcon('mdi:circle-small')
  },
  {
    title: DEALER_SCREEN.DISBURSED_LOANS,
    path: '/dealers/loan_list/loan_disbursed',
    icon: getIcon('mdi:circle-small')
  },
  // {
  //   title: DEALER_SCREEN.CLOSED_LOAN,
  //   path: '/dealers/loan_list/close',
  //   icon: getIcon('mdi:circle-small')
  // },
  // {
  //   title: DEALER_SCREEN.PDD_LOANS,
  //   path: '/dealers/loan_list/loan_disbursed_with_pdd',
  //   icon: getIcon('mdi:circle-small')
  // },
  {
    title: DEALER_SCREEN.PENDING_RC,
    path: '/dealers/missing_rc',
    icon: getIcon('mdi:circle-small')
  },
  // {
  //   title: DEALER_SCREEN.REPO,
  //   path: '/dealers/loan_list/repo',
  //   icon: getIcon('mdi:circle-small')
  // },

  {
    title: 'Leads',
    path: '/dashboard/lead',
    icon: getIcon('eva:people-fill'),
    children: [
    {
      title: 'New Lead',
      path: 'new_lead',
      icon: getIcon('eva:shopping-bag-fill')
    },
    {
      title: 'Customer List',
      path: '/dashboard/leads',
      icon: getIcon('eva:shopping-bag-fill')
    }
    ]
  },
  // {
  //   title: 'Loan',
  //   path: '',
  //   icon: getIcon('mdi:finance'),
  //   children: []
  // },

];

export default sidebarConfig;
